/** @jsx jsx */
import {
  jsx,
  Card as ThemeUICard,
  ResponsiveStyleValue,
  ThemeUIStyleObject,
} from "theme-ui";
import React, { Fragment } from "react";

import { CardStyles } from "./styles";
import { PrimitiveProps } from "@styles/types";

import { LinkField } from "src/carlsberg-headless/types/fields/Link";
import { Link } from "@shared-components/Link/Link";

export const getImageWidthForCard = (
  n: ResponsiveStyleValue<string | number>
):
  | ResponsiveStyleValue<string | number>
  | ResponsiveStyleValue<string | number>[]
  | false => {
  if (Array.isArray(n)) {
    return n.map((w) =>
      getImageWidthForCard(w as string | number)
    ) as ResponsiveStyleValue<string | number>[];
  }
  return !!n && typeof n === "string" ? parseInt(n.split(":")[0]) : n;
};

interface CardLinkProps extends LinkField {
  children?: React.ReactNode;
  sx?: ThemeUIStyleObject;
}

const CardLink: React.FC<CardLinkProps> = (props) => {
  if (props && props.url) {
    return (
      <Link to={props.url} sx={props.sx}>
        {props.children}
      </Link>
    );
  }
  return <Fragment>{props.children}</Fragment>;
};

export interface CardProps extends PrimitiveProps {
  children?: React.ReactNode;
}

const Card: React.FC<CardProps> = ({ children, sx, ...props }) => (
  <ThemeUICard sx={{ ...CardStyles, ...sx }} {...props}>
    {children}
  </ThemeUICard>
);

Card.defaultProps = {};

export { Card, CardLink };
